export default __webpack_public_path__ + "static/media/jace-5.04ec6988.png";